import { Sparkle } from "@phosphor-icons/react";

const ART =
  "https://static.prod-images.emergentagent.com/jobs/8c4d6d9d-84a2-4f25-b806-0954dc297e1c/images/d560b6cb200cf101fcac90aa400cec4857becd7aa861b86cbafb7c6990ab13a2.png";

export const AIInsights = ({ insights, loading }) => {
  return (
    <div
      className="editorial-card grid grid-cols-1 lg:grid-cols-12 gap-0 mt-6"
      data-testid="ai-insights"
    >
      <div className="lg:col-span-4 relative bg-paper-alt overflow-hidden border-b lg:border-b-0 lg:border-r border-paper-edge min-h-[180px] grain">
        <img src={ART} alt="" className="absolute inset-0 w-full h-full object-cover mix-blend-multiply opacity-90" />
        <div className="relative p-6 lg:p-8 h-full flex flex-col justify-between">
          <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-overline text-ink">
            <Sparkle size={14} weight="duotone" className="text-terracotta" />
            <span>Composed by Claude Sonnet 4.5</span>
          </div>
          <div className="font-display italic text-2xl lg:text-3xl text-ink mt-8 lg:mt-12 leading-snug">
            &ldquo;Read the citation record like a manuscript — themes, momentum, and white space.&rdquo;
          </div>
        </div>
      </div>
      <div className="lg:col-span-8 p-6 lg:p-10">
        {loading && !insights ? (
          <div className="space-y-3 animate-pulse" data-testid="insights-loading">
            <div className="h-4 bg-paper-alt w-11/12" />
            <div className="h-4 bg-paper-alt w-10/12" />
            <div className="h-4 bg-paper-alt w-9/12" />
            <div className="h-4 bg-paper-alt w-11/12 mt-6" />
            <div className="h-4 bg-paper-alt w-7/12" />
          </div>
        ) : insights?.summary ? (
          <article className="font-display text-lg lg:text-xl leading-[1.55] text-ink whitespace-pre-line drop-cap" data-testid="insights-text">
            {insights.summary}
          </article>
        ) : (
          <div className="text-ink-mute font-mono text-sm" data-testid="insights-empty">
            Press <em className="font-display not-italic text-ink">Regenerate</em> to compose an editorial reading of this profile.
          </div>
        )}
        {insights?.generated_at && (
          <div className="mt-6 overline" data-testid="insights-timestamp">
            Generated · {new Date(insights.generated_at).toLocaleString()}
          </div>
        )}
      </div>
    </div>
  );
};

export default AIInsights;
